import { getTokenExpirationTimeInSeconds } from './jwt';

const maxTokenCacheTimeToLiveInSeconds = 60 * 10;
const expirationOffsetInSeconds = 30; // Used to prevent caching tokens which will expire in <= 30s

type GetTokenCacheTimeToLive = (token: string) => number | undefined;
export const getTokenCacheTimeToLive: GetTokenCacheTimeToLive = (token) => {
  try {
    const tokenExpirationTimeInSeconds = getTokenExpirationTimeInSeconds(token) - expirationOffsetInSeconds;
    const tokenCacheTimeToLiveInSeconds = tokenExpirationTimeInSeconds - Math.round(Date.now() / 1000.0);

    return Math.min(maxTokenCacheTimeToLiveInSeconds, tokenCacheTimeToLiveInSeconds);
  } catch (error) {
    return undefined;
  }
};

// This YammerCache type is duplicated. Importing from yammer-data or yammer-web-support would cause a circular dependency.
// The compromise was to duplicate this type as it's simple and unlikely to change.
export type GetAuthTokenCache = () => YammerCache | undefined;
export interface YammerCache {
  getItem<T>(key: string): T | null;
  setItem<T>(key: string, value: T, ttlInSeconds?: number): void;
  removeItem(key: string): void;
  clear(): void;
}
